// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MIIS","title":"styles_title__nU4FW"};